<template>
  <v-container fluid>
    <v-layout
      align-center
      justify-center
    >
      <v-flex
        xs12
        sm10
        md8
      >
        <v-card class="elevation-12">
          <v-toolbar
            dark
            color="primary"
            dense
          >
            <v-toolbar-title class="text-no-wrap">{{game.name}}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text class="text-xs-center">
            <div class="ma-1">{{game.description}}</div>
            <v-divider class="mt-2 mb-2"></v-divider>
            <div class="subheading">
              <span
                style="text-decoration: underline;"
                class="blue--text"
              >https://bit.ly/3hHS743</span>
              <span> (Enter Code: <span class="font-weight-black">{{gameOccurrence.code}}</span>)</span>
            </div>
          </v-card-text>
          <v-data-table
            hide-actions
            :headers="headers"
            :items="teams"
            class="pa-2"
          >
            <template
              slot="headers"
              slot-scope="props"
            >
              <tr class="secondary text-xs-left">
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  class="title white--text"
                >
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <template
              slot="items"
              slot-scope="props"
            >
              <tr>
                <td>
                  <v-icon class="mr-3">group</v-icon>{{props.item.name}}
                </td>
                <td>{{props.item.totalEarnedPoints}}</td>
                <td>{{props.item.status}}</td>
              </tr>
            </template>
            <template slot="no-data">
              <v-layout
                align-center
                justify-center
                column
                class="pa-5"
              >
              <v-flex xs1>
                <v-progress-circular
                    :size="70"
                    :width="7"
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
              </v-flex>
              <v-flex xs2 class="mt-3">
                Waiting on teams to join...
              </v-flex>
              </v-layout>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import GameModel from "../../api/game-model";

export default {
  name: "PublicTeamList",
  props: ["code"],
  data() {
    return {
      hostConnected: false,
      headers: [
        {
          text: "Team Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Total Score", value: "score", sortable: true },
        { text: "Status", value: "status", sortable: false }
      ]
    };
  },
  methods: {
    ...mapActions("host", ["joinGame", "connectWebSocket", "refreshTeams"])
  },
  computed: {
    ...mapState("host", {
      apiMessage: state => state.apiMessage,
      game: state => state.game,
      gameOccurrence: state => state.gameOccurrence,
      connectionState: state => state.connectionState,
      gameClientState: state => state.gameClientState,
      teams: state => state.teams
    }),
    ...mapGetters("admin", {
      adminToken: "token"
    }),
    // ...mapGetters("host", {
    //   sortedTeams: "teams"
    // })
  },
  watch: {
    async gameClientState(newState, oldState) {
      if (
          newState === GameModel.GameClientState.REVEAL_CATEGORY_SCORES ||
          newState === GameModel.GameClientState.REVEAL_FINAL_SCORES
      ) {
        // await this.refreshTeams({
        //   gameOccurrenceId: this.gameOccurrence.gameOccurrenceId
        // });
      }
    }
  },
  async created() {
    await this.joinGame({ code: this.code, adminToken: this.adminToken }).catch(
      e => alert("Bummer, we failed to join you in the game as a host... " + e.message)
    );

    await this.refreshTeams({
      gameOccurrenceId: this.gameOccurrence.gameOccurrenceId
    });

    await this.connectWebSocket().catch(e => alert("Bummer, the web socket connection to our server failed... " + e.message));

    this.hostConnected = true;
  }
};
</script>